module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_troendelag_pos.f3af9d20.svg";